// Frontend
import { Link } from 'react-router-dom';
import { Grid, Cell } from 'react-foundation';

import futureWorkDesignLogo from '../images/layout/footer/ForwardTogetherWhiteLogo.svg';

import '../stylesheets/layout/footer/Primary.css';
import '../stylesheets/components/navigation/Footer.css';

export function Footer() {
  return (
    <footer className="primary-footer-wrap">
      <div className="grid-container">
        <Grid>
          <Cell small={12} large={7} className="flex-container align-middle" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={futureWorkDesignLogo}
              loading="lazy"
              alt="Forward Together Logo"
              className="primary-footer__image"
            />
          </Cell>

          <Cell small={12} large={5}>
            <ul className="footer-primary-microcopy-list">
              <li className="footer-primary-microcopy-list__item">
                Copyright Forward Together {new Date().getFullYear()}
              </li>
            </ul>

            <ul className="footer-primary-microcopy-list">
              <li className="footer-primary-microcopy-list__item--small">
                Forward Together tool uses the Stress Indicator Tool. <Link
                    to="https://books.hse.gov.uk/stress-indicator-tool-sit"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-primary-navigation-list__link"
                    style={{ textDecoration: 'underline' }}
                  >
                    The Stress Indicator Tool
                  </Link> is available through Open Government Licence.                  
                    Contains public sector information licensed under the <Link
                    to="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-primary-navigation-list__link"
                    style={{ textDecoration: 'underline' }}
                  >
                    Open Government Licence v3.0
                  </Link>.
              </li>
              <li className="footer-primary-microcopy-list__item--small">
                <Link
                    to="https://forms.office.com/e/xUgib8b90n"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-primary-navigation-list__link"
                    style={{ textDecoration: 'underline' }}
                  >
                    Give us Feedback
                  </Link>.
              </li>              
            </ul>

            <ul className="footer-primary-microcopy-list">
                <li className="footer-primary-navigation-list__item me-5">
                  <Link
                    to={process.env.PUBLIC_URL + '/terms-and-conditions.pdf'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-primary-navigation-list__link"
                  >
                    Terms and Conditions
                  </Link>
                </li>

                <li className="footer-primary-navigation-list__item">
                  <Link
                    to={process.env.PUBLIC_URL + '/privacy-policy.pdf'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-primary-navigation-list__link"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
          </Cell>
        </Grid>
      </div>
    </footer>
  );
}
